import { Link } from "react-router-dom";
import BrandLogo from "../BrandLogo";
import TrustBox from "../TrustBox";
import { FacebookIcon, InstagramIcon, TwitterIcon } from "@/constants/images";
import { Youtube } from "lucide-react";

const Footer = () => {
    const VITE_NEXTJS_URL = import.meta.env.VITE_NEXTJS_URL;
    return (
        <footer className="z-30 bg-gradient-to-r from-blue-50 to-indigo-50 border-t border-blue-100/5 dark:bg-gradient-to-r dark:from-gray-800 dark:to-gray-900 ">
            <div className="container mx-auto px-6 py-8">
                {/* Main Footer Grid */}
                <div className="grid grid-cols-1 md:grid-cols-5 gap-8 pb-8">
                    {/* Brand Column - Spans 2 columns */}
                    <div className="md:col-span-2 flex flex-col gap-6">
                        <div>
                            <BrandLogo className="mb-3 w-max" />
                            <p className="text-gray-600 dark:text-gray-300 text-sm leading-relaxed">
                                Create intelligent AI assistants for your website in minutes
                                without coding.
                            </p>
                        </div>

                        <div>
                            <p className="text-gray-600 dark:text-gray-300 text-sm mb-3">
                                TheQuickAssist is a product of{" "}
                                <Link
                                    to="https://prominno.com/"
                                    target="_blank"
                                    className="font-semibold text-indigo-700 dark:text-indigo-400 hover:text-indigo-800 dark:hover:text-indigo-300 transition-colors"
                                >
                                    Prominno Labs Pvt. Ltd.
                                </Link>
                            </p>

                            <div className="flex gap-3">
                                <a
                                    href="https://www.instagram.com/thequickassist/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="transform transition-transform hover:scale-110"
                                    aria-label="Instagram"
                                >
                                    <img src={InstagramIcon} alt="Instagram" width={32} height={32} className="w-8 h-8" />
                                </a>
                                <a
                                    href="https://www.facebook.com/profile.php?id=61575158037374"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="transform transition-transform hover:scale-110"
                                    aria-label="Facebook"
                                >
                                    <img src={FacebookIcon} alt="Facebook" width={32} height={32} className="w-8 h-8" />
                                </a>
                                <a
                                    href="https://x.com/thequickassist"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="transform transition-transform hover:scale-110"
                                    aria-label="Twitter"
                                >
                                    <img src={TwitterIcon} alt="Twitter" width={32} height={32} className="w-8 h-8" />
                                </a>
                                <a
                                    href="https://www.linkedin.com/company/thequickassist-ai/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="transform transition-transform hover:scale-110"
                                    aria-label="LinkedIn"
                                >
                                    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <g clipPath="url(#clip0_1308_16369)">
                                            <path fillRule="evenodd" clipRule="evenodd" d="M7.22656 0H24.7734C26.6884 0.00552235 28.5233 0.772212 29.8773 2.13258C31.2314 3.49294 31.9945 5.3364 32 7.26024V24.7424C31.9938 26.6658 31.2304 28.5086 29.8764 29.8684C28.5224 31.2282 26.6879 31.9945 24.7734 32H7.22656C5.3121 31.9945 3.47758 31.2282 2.1236 29.8684C0.769619 28.5086 0.00618337 26.6658 0 24.7424V7.26024C0.00549674 5.3364 0.76863 3.49294 2.12268 2.13258C3.47674 0.772212 5.31165 0.00552235 7.22656 0Z" fill="#0A66C2" />
                                            <path fillRule="evenodd" clipRule="evenodd" d="M12.8099 12.4038H16.8542V14.4969H16.9115C17.4766 13.4818 18.8516 12.4038 20.9063 12.4038C25.1745 12.4038 25.9635 15.0725 25.9635 18.5443V25.8857H21.7474V19.3606C21.7474 17.8667 21.7161 15.9437 19.5547 15.9437C17.3932 15.9437 17.0234 17.5684 17.0234 19.2533V25.8987H12.8099V12.4038ZM10.4167 8.31718C10.4167 8.75288 10.2881 9.1788 10.0471 9.54107C9.80619 9.90334 9.46374 10.1857 9.06307 10.3524C8.66241 10.5192 8.22153 10.5628 7.79618 10.4778C7.37084 10.3928 6.98014 10.183 6.67348 9.87489C6.36682 9.5668 6.15799 9.17428 6.07338 8.74695C5.98878 8.31963 6.0322 7.87669 6.19816 7.47416C6.36412 7.07163 6.64517 6.72758 7.00576 6.48552C7.36634 6.24346 7.79028 6.11426 8.22396 6.11426C8.80529 6.11495 9.36261 6.34727 9.77368 6.76024C10.1847 7.17322 10.416 7.73314 10.4167 8.31718ZM6.03646 12.4038H10.4167V25.8857H6.03646V12.4038Z" fill="white" />
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_1308_16369">
                                                <rect width="32" height="32" fill="white" />
                                            </clipPath>
                                        </defs>
                                    </svg>
                                </a>
                                <a
                                    href="https://www.youtube.com/@TheQuickAssistAutomationHub/shorts"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="transform transition-transform hover:scale-110"
                                    aria-label="YouTube"
                                >
                                    <div className="w-8 h-8 bg-[#FF0000] rounded-sm flex items-center justify-center shadow-sm">
                                        <Youtube className="w-5 h-5 text-white" />
                                    </div>
                                </a>
                            </div>
                        </div>
                    </div>
                    {/* Free Tools Section */}
                    <div>
                        <h3 className="font-semibold mb-4 !text-sm uppercase tracking-wider dark:text-white">
                            Free Tools
                        </h3>
                        <ul className="space-y-3">
                            <li>
                                <Link
                                    to={`${VITE_NEXTJS_URL}/free-tools`}
                                    className="!text-gray-600 hover:!text-indigo-600 dark:!text-gray-400 dark:hover:!text-indigo-400 !text-sm transition-colors block"
                                >
                                    All Free Tools
                                </Link>
                            </li>
                            <li>
                                <Link
                                    to={`${VITE_NEXTJS_URL}/free-tools/free-whatsapp-link-generator`}
                                    className="!text-gray-600 hover:!text-indigo-600 dark:!text-gray-400 dark:hover:!text-indigo-400 !text-sm transition-colors block"
                                >
                                    Free WhatsApp Link Generator
                                </Link>
                            </li>
                            <li>
                                <Link
                                    to={`${VITE_NEXTJS_URL}/free-tools/whatsapp-chat-button`}
                                    className="!text-gray-600 hover:!text-indigo-600 dark:!text-gray-400 dark:hover:!text-indigo-400 !text-sm transition-colors block"
                                >
                                    WhatsApp Chat Button
                                </Link>
                            </li>
                            <li>
                                <Link
                                    to={`${VITE_NEXTJS_URL}/free-tools/whatsapp-qr-code-generator`}

                                    className="!text-gray-600 hover:!text-indigo-600 dark:!text-gray-400 dark:hover:!text-indigo-400 !text-sm transition-colors block"
                                >
                                    WhatsApp QR Code Generator
                                </Link>
                            </li>
                        </ul>
                    </div>
                    {/* Legal Section */}
                    <div>
                        <h3 className="font-semibold mb-4 !text-sm uppercase tracking-wider dark:text-white">
                            Legal
                        </h3>
                        <ul className="space-y-3">
                            <li>
                                <Link
                                    to={`${VITE_NEXTJS_URL}/privacyPolicy`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="!text-gray-600 hover:!text-indigo-600 dark:!text-gray-400 dark:hover:!text-indigo-400 !text-sm transition-colors block"
                                >
                                    Privacy Policy
                                </Link>
                            </li>
                            <li>
                                <Link
                                    to={`${VITE_NEXTJS_URL}/cookie-policy`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="!text-gray-600 hover:!text-indigo-600 dark:!text-gray-400 dark:hover:!text-indigo-400 !text-sm transition-colors block"
                                >
                                    Cookie Policy
                                </Link>
                            </li>
                            <li>
                                <Link
                                    to={`${VITE_NEXTJS_URL}/termsAndCondition`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="!text-gray-600 hover:!text-indigo-600 dark:!text-gray-400 dark:hover:!text-indigo-400 !text-sm transition-colors block"
                                >
                                    Terms of Service
                                </Link>
                            </li>
                        </ul>
                    </div>

                    {/* Company Section */}
                    <div>
                        <h3 className="font-semibold mb-4 !text-sm uppercase tracking-wider dark:text-white">
                            Company
                        </h3>
                        <ul className="space-y-3">
                            <li>
                                <Link
                                    to={`${VITE_NEXTJS_URL}/affiliate`}
                                    rel="noopener noreferrer"
                                    className="!text-gray-600 hover:!text-indigo-600 dark:!text-gray-400 dark:hover:!text-indigo-400 !text-sm transition-colors block"
                                >
                                    Affiliate Program
                                </Link>
                            </li>
                            <li>
                                <Link
                                    to={`${VITE_NEXTJS_URL}/cancellationAndRefunds`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="!text-gray-600 hover:!text-indigo-600 dark:!text-gray-400 dark:hover:!text-indigo-400 !text-sm transition-colors block"
                                >
                                    Cancellation & Refunds
                                </Link>
                            </li>
                            <li>
                                <Link
                                    to={`${VITE_NEXTJS_URL}/shipping`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="!text-gray-600 hover:!text-indigo-600 dark:!text-gray-400 dark:hover:!text-indigo-400 !text-sm transition-colors block"
                                >
                                    Shipping
                                </Link>
                            </li>
                            <li>
                                <Link
                                    to={`${VITE_NEXTJS_URL}/contactUs`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="!text-gray-600 hover:!text-indigo-600 dark:!text-gray-400 dark:hover:!text-indigo-400 !text-sm transition-colors block"
                                >
                                    Contact Us
                                </Link>
                            </li>
                        </ul>
                    </div>
                </div>

                {/* Bottom Bar: Copyright and Trustpilot */}
                <div className="border-t border-gray-200 dark:border-gray-700 pt-6 mt-2">
                    <div className="flex flex-col md:flex-row justify-between items-center gap-4">
                        <p className="!text-gray-500 dark:!text-gray-400 !text-sm ">
                            © {new Date().getFullYear()} TheQuickAssist.co. All rights reserved.
                        </p>
                        {/* TrustBox widget - Review Collector */}
                        <TrustBox
                            templateId="56278e9abfbbba0bdcd568bc"
                            businessunitId="69119bdffb3fc94434b58bba"
                            locale="en-US"
                            styleHeight="52px"
                            styleWidth="100%"
                            token="d3e77872-50c6-482c-945e-df11adb42799"
                        />
                        {/* <p className="text-gray-500 dark:text-gray-300 text-sm ">
                            © {new Date().getFullYear()} TheQuickAssist.co. All rights reserved.
                        </p> */}
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
